import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, HelpBlock, ButtonToolbar, ControlLabel, FormControl } from 'react-bootstrap';

import CancelModal from '../CancelModal.jsx';

class ContactInfoForm extends Component {
  constructor(props) {
    super();

    this.state = {
      executor: { status: null, error: '' },
      contact_name: { status: null, error: '' },
      contact_email: { status: null, error: '' },
      disableNextButton: false,
      showCancelConfirm: false
    };
  }

  handleChange = (e) => {
    this.props.handleChange(e.target.name, e.target.value);
    this.setState(this.props.displayError(e.target.name));
  }

  checkValidationErrors = () => {
    const state = this.props.checkValidationErrors(this.state);
    this.setState({ state });
  }

  render() {
    return (
      <Form>
        <FormGroup validationState={this.state.executor.status}>
          <br />
          <ControlLabel>Toteuttajatahot</ControlLabel>
          <FormControl
            value={this.props.state.formData.executor || ''}
            name="executor"
            placeholder="Esim. Lapin pelastuslaitos, Sisäministeriön pelastuslaitos, Suomen Punainen Risti"
            type="text"
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.executor.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.contact_name.status}>
          <ControlLabel>Yhteyshenkilöt</ControlLabel>
          <FormControl
            value={this.props.state.formData.contact_name || ''}
            name="contact_name"
            placeholder="Esim. Matti Meikäläinen, Pekka Pelastaja"
            type="text"
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.contact_name.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.contact_email.status}>
          <ControlLabel>Yhteyshenkilöiden sähköpostit</ControlLabel>
          <FormControl
            value={this.props.state.formData.contact_email || ''}
            name="contact_email"
            placeholder="Esim. esimerkki@sposti.fi, esim123@gmail.com"
            type="text"
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.contact_email.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={null}>
          <ControlLabel>Yhteyshenkilöiden puhelinnumerot</ControlLabel>
          <FormControl
            value={this.props.state.formData.contact_phone || ''}
            name="contact_phone"
            placeholder="Esim. +3285112951, 047684172534"
            type="text"
            onChange={this.handleChange}
          />
          <HelpBlock>{''}</HelpBlock>
        </FormGroup>

        <ButtonToolbar>
          <br />
          <Button bsStyle="primary" onClick={this.props.previousPage}>
            Edellinen
          </Button>
          <Button bsStyle="primary" disabled={this.state.disableNextButton} onClick={this.checkValidationErrors}>
            Seuraava
          </Button>
          <Button onClick={() => this.setState({ showCancelConfirm: true })} >
            Keskeytä
          </Button>

          <CancelModal
            show={this.state.showCancelConfirm}
            handleCancel={this.props.handleCancel}
            disableCancelConfirm={() => this.setState({ showCancelConfirm: false })}
          />
        </ButtonToolbar>
      </Form>
    );
  }
}

ContactInfoForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  displayError: PropTypes.func.isRequired,
  checkValidationErrors: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired
};

export default ContactInfoForm;



// WEBPACK FOOTER //
// ./src/components/forms/ContactInfoForm.jsx